import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  main: {
    textAlign: 'center',
  },
}))
